export interface RollLayoutDocument {
	DocumentName: string;
	DocumentPath: string;
}

// Base URL of the roanoke document store that serves the layout PDFs.
export const DOCS_BASE_URL = "https://mill-cmms.roanokesteel.com/docs/";

export const buildDocumentUrl = (documentPath: string): string =>
	DOCS_BASE_URL + documentPath;
